// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateVendorMutation($input: UpdateVendorInput!) {
    updateVendor(input: $input) {
      vendor {
        id
        vendorNumber
        name
        email
        phone
        address
        city
        state
        zipCode
        country
        paymentTerms
        rating
        createdAt
        updatedAt
        itemPrices {
          edges {
            node {
              id
              item {
                id
                name
              }
              unitPrice
              leadTimeDays
              isPreferred
            }
          }
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
